import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class RadiationAttribute extends Sensor {
  public radiationChart: any;
  private radiationSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.radiationChart = null;
    this.radiationSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.radiationSensor, position);
      this.radiationSensor[position].push([timestamp, element.radiation]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredRadiation = this.radiationSensor.filter(series => series.length > 0);

    const positionNodeRadiation = this.radiationSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.radiationChart = this.getConfigChar(
      'radiation',
      this.getChartSeriesNewNode('Sensor', filteredRadiation, positionNodeRadiation),
      this.getRanges('radiation'),
      this.getLimits('radiation')
    );
  }

  public hasRadiationSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.radiationSensor.length &&
      this.radiationSensor[index].length > 0
    );
  }

  public getRadiationSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.radiationSensor.length) {
      const sensorData = this.radiationSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Radiación Solar', value: 'radiation' }
    ];
  }
}
